'use client'

import { lazy, Suspense } from 'react'

// Lazy load React Query Devtools to avoid SSR issues
const ReactQueryDevtoolsProduction = lazy(() =>
  import('@tanstack/react-query-devtools').then((d) => ({
    default: d.ReactQueryDevtools,
  })),
)

export function ReactQueryDevtoolsWrapper() {
  // Only render on client
  if (typeof window === 'undefined') {
    return null
  }

  return (
    <Suspense fallback={null}>
      <ReactQueryDevtoolsProduction
        initialIsOpen={false}
        buttonPosition="bottom-left"
      />
    </Suspense>
  )
}
